module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_upward_shadow.ff008a6c.png";